import { createAction, props } from '@ngrx/store';

export const changeSplashVisibility = createAction(
    '[Splash] Change splash visibility',
    props<{ visible: boolean; logoUrl?: string }>(),
);
